import React from "react";

import styles from "./sidebar.module.css";

import Header from "./Header";
import Wallet from "./Wallet";
import Profile from "./Profile";
import Notification from "./Notification";
import Menu from "./Menu";
import { useSidebarContext } from "./Context";

export default function SideBar({ appModules }) {
  return (
    <Nav>
      <Header />
      <Wallet />
      <Menu appModules={appModules} />
      <Notification />
      <Profile />
    </Nav>
  );
}

function Nav({ children }) {
  const { isSidebarCollapsed } = useSidebarContext();
  return (
    <nav
      className={`${styles.sidebar} ${isSidebarCollapsed ? styles.close : ""}`}
    >
      {children}
    </nav>
  );
}
